import css from "./oem.module.scss";
import { Layout } from "../../componentsV1/layout";
import Logo from "../../assets/v1/logo.png";
import { Multiplexing, ScientificValidation, Graph, PremiumChemistry, Manufacturing } from "../../assets/v1/icons";

export const OEM = () => {
  const conjugations = ['Conventional Fluorescence', 'Super-Resolution Microscopy', 'Single Molecule Localization Microscopy (SMLM)', 'Near Infrared (NIR) Imaging', 'Immunohistochemistry (IHC)', 'Multiplex Imaging']
  const manufacturing = ['Research Use Only (RUO)', 'Preclinical Research', 'Commercial Supply', 'Distribution Programs']
  const programs = ['Secondary Antibodies', 'Direct Conjugates', 'Near Infrared Reagents', 'Complete Product Lines']
  const applications = ['Diagnostic Assays', 'Companion Diagnostics', 'Imaging Reagents', 'Research Platforms', 'Instrument-Based Solutions']
  const services = ['Product Design', 'Reagent Development', 'Conjugation Chemistry', 'Validation Strategies', 'Manufacturing Scale-Up', 'Scientific Consultation']
  const why = ['Custom Chemistry', 'Advanced Imaging', 'Stepdown™ Validation', 'Scalable Manufacturing', 'Commercialization Support']

  const logos = [
    {
      icon: PremiumChemistry,
      text: "Premium Chemistry"
    },
    {
      icon: ScientificValidation,
      text: "Scientific Validation"
    },
    {
      icon: Graph,
      text: "Manufacturing Scale"
    },
    {
      icon: Manufacturing,
      text: "OEM Partnerships"
    }
  ]

  return (
    <Layout>
      <div className={css.heroContainer}>
        <div className={css.heroContent}>
          <img src={Logo} alt="logo" className={css.heroLogo} />
          <div className={css.heroText}>
            <h1>From Concept to <br /> Commercialization.</h1>
            <div className={css.line} />
            <p>Whether you're developing a novel reagent, expanding an existing product line, or launching an OEM program, Identifyn® provides the chemistry, manufacturing, validation, and commercialization expertise to bring advanced fluorescence products to market.</p>
          </div>
          <div className={css.logoContainer}>
            {logos.map((item) => {
              return (
                <div className={css.logo}>
                  <img src={item.icon} alt={item.text} />
                  <p>{item.text}</p>
                </div>
              )
            })
            }
          </div>
        </div>
      </div>
      <div className={css.container}>
        {/* first section */}
        <div className={`${css.column} ${css.centerText}`}>
          <div className={`${css.column} ${css.centerText}`} style={{ maxWidth: "730px", margin: "0 auto" }}>
            <h5 className={css.specialText}>Transform Your Antibody Into a Market-Ready Product</h5>
            <h2 className={css.heading}>Custom Conjugation</h2>
            <p>Not every antibody manufacturer has the expertise required to produce high-performance fluorescent reagents for advanced imaging.</p>
            <p>We can conjugate antibodies from virtually any source, producing imaging-ready reagents engineered for your specific application.</p>
          </div>
          <div className={css.threeColumn}>
            {conjugations.map((item) => {
              return (
                <div className={css.pillCard} key={item}>
                  <p>
                    {item}
                  </p>
                </div>
              )
            })}
          </div>
          <p>From a single custom conjugate to full commercial manufacturing, Identifyn® provides the chemistry, validation, and manufacturing expertise required to bring advanced fluorescence reagents to market.</p>
        </div>
        {/* second section */}
        <div className={`${css.column} ${css.centerText}`}>
          <div className={`${css.column} ${css.centerText}`} style={{ maxWidth: "730px", margin: "0 auto" }}>
            <h5 className={css.specialText}>Reduce Cost. Increase Scale.</h5>
            <h2 className={css.heading}>Bulk Manufacturing</h2>
            <p>Producing fluorescent reagents in-house can require significant investments in personnel, equipment, quality control, and manufacturing infrastructure. Identifyn® provides scalable bulk manufacturing services that reduce production costs while maintaining consistency, performance, and supply continuity.</p>
          </div>
          <div className={css.fourColumn}>
            {manufacturing.map((item) => {
              return (
                <div className={css.pillCard} key={item}>
                  <p>
                    {item}
                  </p>
                </div>
              )
            })}
          </div>
          <p>From pilot production through commercial manufacturing, Identifyn® becomes an extension of your production team—delivering reliable reagent supply without the cost of building manufacturing infrastructure.</p>
        </div>
        {/* third section */}
        <div className={`${css.column} ${css.centerText}`}>
          <div className={`${css.column} ${css.centerText}`} style={{ maxWidth: "730px", margin: "0 auto" }}>
            <h5 className={css.specialText}>Build Your Brand. Powered by Identifyn®.</h5>
            <h2 className={css.heading}>Private Label Programs</h2>
            <p className={css.italic}>Launch your own branded reagent portfolio without the time, infrastructure, or investment required to build it yourself.</p>
            <p>Expand your product portfolio without investing in internal reagent development or manufacturing. Our private label programs enable partners to market high-performance fluorescence reagents under their own brand while leveraging Identifyn® manufacturing, quality systems, and scientific expertise.</p>
          </div>
          <div className={css.fourColumn}>
            {programs.map((item) => {
              return (
                <div className={css.pillCard} key={item}>
                  <p>
                    {item}
                  </p>
                </div>
              )
            })}
          </div>
          <p>Private label partners may also incorporate optional Stepdown™ Validation Programs, providing independent imaging validation that enhances product confidence and creates meaningful differentiation in a competitive marketplace.</p>
        </div>
        {/* fourth section */}
        <div className={`${css.column} ${css.centerText}`}>
          <div className={`${css.column} ${css.centerText}`} style={{ maxWidth: "730px", margin: "0 auto" }}>
            <h5 className={css.specialText}>Become More Than a Customer. Become a Partner.</h5>
            <h2 className={css.heading}>OEM Partnerships</h2>
            <p>For organizations seeking more than a contract manufacturer, Identifyn® offers flexible OEM partnerships that combine scientific expertise, reagent development, manufacturing, and commercialization support. We work alongside your team to help bring innovative products to market.</p>
          </div>
          <div className={css.twoColumn}>
            <div className={`${css.card} ${css.column} ${css.alignLeft}`}>
              <p>OEM Applications</p>
              <div className={css.singleColumn}>
                {applications.map((item) => {
                  return (
                    <div className={css.pillCard} key={item}>
                      <p>
                        {item}
                      </p>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className={`${css.card} ${css.column} ${css.alignLeft}`}>
              <p>Partnership Services</p>
              <div className={css.singleColumn}>
                {services.map((item) => {
                  return (
                    <div className={css.pillCard} key={item}>
                      <p>
                        {item}
                      </p>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
          {/* <div className={css.threeColumn}>
            {applications.map((item) => {
              return (
                <div className={css.pillCard} key={item}>
                  {item}
                </div>
              )
            })}
          </div> */}
          <p>Whether supporting a single product or an entire platform, Identifyn® serves as an extension of your scientific and manufacturing teams—providing the expertise, infrastructure, and scalability required for long-term success.</p>
        </div>
        {/* fifth section */}
        <div className={`${css.smallContainer} ${css.card} ${css.centerText} ${css.column}`}>
          <h5 className={css.specialText}>One Integrated Imaging Standard</h5>
          <h2 className={css.heading}>Why Identifyn® Is Different</h2>
          <p>Most manufacturers focus solely on production. Identifyn® combines:</p>
          <div className={`${css.singleColumn} ${css.alignLeft}`}>
            {why.map((item) => {
              return (
                <div className={css.pillCard} key={item}>
                  <p>
                    {item}
                  </p>
                </div>
              )
            })}
          </div>
          <p>Our integrated approach ensures products are engineered not only for manufacturability, but also for biological performance, imaging quality, and commercial success.</p>
        </div>
        {/* sixth section */}
        <div className={`${css.column} ${css.centerText} ${css.smallContainer} ${css.card} ${css.shadowCard}`}>
          <h2 className={css.heading}>From Concept to Commercialization</h2>
          <p>Whether you're developing a novel assay, expanding your product portfolio, or launching a complete OEM program, Identifyn® provides the scientific expertise, manufacturing infrastructure, and commercialization support to help bring your products to market with confidence.</p>
          <button className={`btn ${css.ctaBtn}`}>Discuss Your Program</button>
          <div className={`${css.twoColumn} ${css.centerText}`}>
            <a href="mailto:services@identifyn.com" className={css.link}>services@identifyn.com</a>
            <a href="tel:+19415290647" className={css.link}>(941) 529-0647</a>
          </div>
        </div>
      </div>
    </Layout>
  );
}